package com.macrofocus.eflux.components

import mui.icons.material.Air
import mui.icons.material.Opacity
import mui.icons.material.Speed
import mui.icons.material.Thermostat
import mui.material.*
import mui.material.styles.TypographyVariant
import mui.system.responsive
import mui.system.sx
import react.FC
import react.Props
import web.cssom.px
import web.cssom.rgb

external interface WeatherPanelProps : Props {
    var temperature: String?
    var wind: String?
    var gust: String?
    var precipitation: String?
    var lightning: String?
}

val WeatherPanel = FC<WeatherPanelProps> { props ->
    Card {
        sx {
            padding = 2.px
            borderRadius = 8.px
//            boxShadow = 2.px
            maxWidth = 280.px
            backgroundColor = rgb(255, 255, 255, 0.2)
        }
        CardContent {
            sx {
                paddingTop = 4.px

                "&:last-child" {
                    paddingBottom = 4.px
                }
            }

            Grid {
                container = true
                spacing = responsive(2)

                // Temperature
                Grid {
                    asDynamic().item = true
//                    xs = 6
                    Stack {
                        direction = responsive(StackDirection.row)
                        spacing = responsive(1)
                        Thermostat {
                            fontSize = SvgIconSize.small
                        }
                        Typography {
                            variant = TypographyVariant.subtitle2
                            +props.temperature
                        }
                    }
                }

                // Wind
                Grid {
                    asDynamic().item = true
//                    xs = 6
                    Stack {
                        direction = responsive(StackDirection.row)
                        spacing = responsive(1)
                        Air {
                            fontSize = SvgIconSize.small
                        }
                        Typography {
                            variant = TypographyVariant.subtitle2
                            +props.wind
                        }
                    }
                }

                // Precipitation
                Grid {
                    asDynamic().item = true
//                    xs = 6
                    Stack {
                        direction = responsive(StackDirection.row)
                        spacing = responsive(1)
                        Opacity {
                            fontSize = SvgIconSize.small
                        }
                        Typography {
                            variant = TypographyVariant.subtitle2
                            +props.precipitation
                        }
                    }
                }

                // Wind gust
                Grid {
                    asDynamic().item = true
//                    xs = 6
                    Stack {
                        direction = responsive(StackDirection.row)
                        spacing = responsive(1)
                        Speed {
                            fontSize = SvgIconSize.small
                        }
                        Typography {
                            variant = TypographyVariant.subtitle2
                            +props.gust
                        }
                    }
                }

                // Lightning
//                Grid {
//                    item = true
////                    xs = 6
//                    Stack {
//                        direction = responsive(StackDirection.row)
//                        spacing = responsive(1)
//                        FlashOn() // lightning icon
//                        Typography {
//                            variant = TypographyVariant.subtitle2
//                            +props.lightning
//                        }
//                    }
//                }
            }
        }
    }
}
